<script>
    import VcPaginacao from "./Paginacao.vue";
    import Bus from "../../bus"

    export default {
        inject: ['$validator'],
        props: {
            'nomeInput': {}, 'label': {}, 'selecionado': {}, 'selecionadoConfig': {},
            'obrigatorio': {default: null}, 'limpaSelect': {default: false},
            'urlBusca': {}, 'camposTable': {}, 'extra': {}, 'conexao': {}
        },
        components: {
            VcPaginacao,
        },
        data() {
            return {
                parametroPesquisa: '',
                dados: [],
                pagination: {},
                dadosDefault: {},
                selecionadoComponente: {}
            }
        },
        computed: {
            isRequired() {
                return this.obrigatorio != null && this.obrigatorio.length > 0
            }
        },
        watch: {
            parametroPesquisa: function () {
                this.navigate(1)
            },
            extra: function () {
                this.navigate(1);
            },
            selecionado(objeto) {
                if (objeto !== undefined && objeto !== null) {
                    this.selecionar(null, objeto)
                } else {
                    this.$set(this, 'selecionadoComponente', {})
                    this.$set(this, 'parametroPesquisa', '')
                    $("#pesquisa" + this._uid).val('');
                }
            }
        },
        methods: {
            navigate(page) {
                let conexao = (this.conexao === 'numerama' ? this.$httpNumerama : this.$http);
                conexao.post(this.urlBusca + '?page=' + page, Object.assign({}, {parametro: this.parametroPesquisa}, this.extra)).then((response) => {
                    this.dados = response.data.data;
                    this.pagination = response.data;
                });
            },
            selecionar($e, objeto) {
                $("#pesquisa" + this._uid).val(objeto[this.selecionadoConfig.label]);
                this.$set(this, 'selecionadoComponente', objeto);
                this.$emit('input', objeto);
                this.fechaModal();
            },
            fechaModal: function () {
                return $('.vue-pesquisa' + this._uid + '.modal').modal('hide');
            },
            abreModal() {
                this.navigate(1);
                let modalHtml = $(".vue-pesquisa" + this._uid + ".modal");
                modalHtml.modal();
                modalHtml.find("input").focus();
            }
        },
        mounted() {
            if (this.selecionado !== undefined && this.selecionado !== null) {
                this.selecionar(null, this.selecionado)
            }

            Bus.$on('limpa-select', () => {
                if (this.limpaSelect) {
                    this.$set(this, 'selecionadoComponente', {})
                    this.$set(this, 'parametroPesquisa', '')
                    $("#pesquisa" + this._uid).val('');
                }
            })
        }
    }
</script>

<template>
    <div class="pesquisa">

        <div class="form-group" :class="{'has-error': isRequired && errors.has(obrigatorio)}">
            <label>{{label}}</label>
            <div class="input-group">
                <span class="input-group-addon" @click="abreModal()">
                    <i title="Pesquisar" class="text-success fa fa-search"></i>
                </span>
                <div v-if="isRequired">
                    <input type="text" :id="'pesquisa' + _uid" class="form-control" readonly @focus="abreModal"
                           v-validate="'required'" :data-vv-name="obrigatorio"/>
                </div>
                <div v-else>
                    <input type="text" :id="'pesquisa' + _uid" class="form-control" readonly @focus="abreModal"/>
                </div>
                <input type="hidden" :value="selecionadoComponente.id" :name="nomeInput">
            </div>

        </div>

        <div :class="'vue-pesquisa' + _uid" class="modal" role="dialog" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog tamanho-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Pesquisar</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Digite algo para pesquisar</label>
                                    <input type="text" class="form-control" v-model="parametroPesquisa"/>
                                </div>
                            </div>
                        </div>

                        <table class="table table-striped table-bordered  table-hover tabela-pesquisa"
                               v-if="dados != undefined">
                            <thead>
                            <tr>
                                <th v-for="ct in camposTable">{{ ct.label }}</th>
                            </tr>
                            </thead>

                            <tbody v-for="dado in dados">
                            <tr @click="selecionar($event, dado)" class="clickabe-tr">
                                <td v-for="ct in camposTable">
                                    {{ ct.subCampo == undefined ? dado[ct.campo] : dado[ct.campo][ct.subCampo] }}
                                </td>
                            </tr>
                            </tbody>

                            <tbody v-if="dados.length <= 0">
                            <tr>
                                <td class="text-center" :colspan="camposTable.length">
                                    <span class="text-danger">Atenção!</span>
                                    <br/>Não encontramos nenhum registro com os dados informados!
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>

                    </div>
                    <div class="modal-footer">
                        <span class="pull-left">* Clique no registro para selecionar</span>
                        <button type="button" class="btn btn-effect-ripple btn-danger" @click="fechaModal()">Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .pesquisa {
        font-size: 14px !important;
    }

    @media screen and (max-width: 450px) {
        table td {
            max-width: 12ch;
            overflow-x: auto;
        }
    }

</style>
